import GlpNumber from './GlpNumber.vue'

export { GlpNumber }
